import { ReactNode, useMemo } from 'react'
import { WidgetContextProvider } from './providers'
import { useActiveCompetitions } from '../navigation/api'
import { useCompetitionId } from '../common/hooks'

interface CompetitionContextProviderProps {
  children: ReactNode
}

export function CompetitionContextProvider({
  children,
}: CompetitionContextProviderProps) {
  const competition_id = useCompetitionId()
  const { data } = useActiveCompetitions()
  const competitions = data?.competitions || []

  const competitionDates = useMemo(() => {
    const currentCompetition = competitions?.find(
      (c) => c.competition_id === competition_id
    )

    if (!currentCompetition) {
      return {}
    }

    return {
      competition_id,
      competition_start: currentCompetition.starts_at,
      competition_end: currentCompetition.ends_at,
    }
  }, [competitions, competition_id])

  return (
    <WidgetContextProvider context={competitionDates}>
      {children}
    </WidgetContextProvider>
  )
}
